import axios from 'axios'
import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FModal from '~/js/components/modal'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import { REGIONS } from '~/js/templates/page/stores/constants'

// Shopify APIのmetaobjectsクエリは最大250件まで取得可能
const METAOBJECTS_PAGE_SIZE = 250
// Shopify APIバージョン
const SHOPIFY_API_VERSION = '2025-01'

const getProductStoresStock = async (sku) => {
  if (!sku) return

  const url = `${baseUrlFrontApi}/storestock/${sku}`

  try {
    return await $.ajax({
      url,
      type: 'GET',
      crossDomain: true,
      cache: true,
      dataType: 'json',
    }).then((result) => {
      return result
    })
  } catch (e) {
    console.error(e)
  }
}

/**
 * 全店舗情報を取得する
 * @returns {Promise<Array>} 店舗のメタオブジェクト配列
 */
const fetchAllStores = async () => {
  const element = document.getElementById('js-product-stock-settings')
  if (!element) return []

  const dataset = element.dataset
  const storefrontAccessToken = dataset.storefrontAccessToken
  if (!storefrontAccessToken) return []

  let allStores = []
  let hasNextPage = true
  let cursor = null

  while (hasNextPage) {
    try {
      const response = await axios.post(
        `/api/${SHOPIFY_API_VERSION}/graphql.json`,
        {
          query: `
            query($type: String!, $cursor: String) {
              metaobjects(type: $type, first: ${METAOBJECTS_PAGE_SIZE}, after: $cursor) {
                nodes {
                  handle
                  fields {
                    key
                    value
                  }
                }
                pageInfo {
                  hasNextPage
                  endCursor
                }
              }
            }
          `,
          variables: {
            type: 'stores',
            cursor: cursor,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
        }
      )
      if (response.data.errors) {
        console.error('GraphQL Errors:', response.data.errors)
        break
      }

      const data = response.data?.data?.metaobjects
      if (!data) {
        console.error('Invalid GraphQL response', response.data)
        break
      }
      allStores = allStores.concat(data.nodes)
      hasNextPage = data.pageInfo.hasNextPage
      cursor = data.pageInfo.endCursor
    } catch (error) {
      console.error('Axios Error:', error.response?.data || error.message)
      break
    }
  }
  return allStores
}

export const initStoresStockModal = async (element) => {
  const sku = element.dataset.sku
  const storesStock = await getProductStoresStock(sku)
  const elementSettings = document.getElementById('js-product-stock-settings')
  const settings = elementSettings.dataset

  const storesList = await fetchAllStores()
  const regionKeys = Object.keys(REGIONS)
  const indexSelectedRegion = regionKeys.indexOf('東京')
  const storesListWithStatus = (storesList || [])
    .map((store) => {
      const fieldsObj = (store.fields || []).reduce((acc, field) => {
        acc[field.key] = field.value
        return acc
      }, {})
      const stock = storesStock.find(
        (s) => String(s.store_id) === String(store.handle)
      )
      return {
        name: fieldsObj.name || '',
        region: fieldsObj.region || '',
        prefecture: fieldsObj.prefecture || '',
        status: stock ? stock.status : 'NONE',
        is_closed: fieldsObj.is_closed,
        store_page_param: fieldsObj.store_page_param || '',
        handle: store.handle,
      }
    })
    .filter(
      (store) =>
        store.is_closed === false ||
        store.is_closed === 'false' ||
        store.is_closed === undefined
    )

  const storesGrouped = regionKeys.map((region) => {
    const prefectures = REGIONS[region]
    return prefectures.map((prefecture) => {
      const stores = storesListWithStatus
        .filter((store) => store.prefecture === prefecture)
        .filter((store) => {
          // 在庫状況と設定に応じて表示する店舗をフィルター
          return !(
            (settings.hideStoresNoStock == 'true' && store.status === 'NONE') ||
            (settings.hideStoresBelowThresholdStock == 'true' &&
              store.status === 'LOW') ||
            (settings.hideStoresAboveThresholdStock === 'true' &&
              store.status === 'ENOUGH')
          )
        })
        .map((store) => {
          // 在庫状況によって表示するテキストをセット
          let stockText = '---'
          if (store.status === 'NONE') stockText = settings.noStockText
          else if (store.status === 'LOW') stockText = settings.lowStockText
          else if (store.status === 'ENOUGH') stockText = settings.highStockText
          return {
            ...store,
            stockText,
          }
        })

      return {
        prefecture,
        stores,
      }
    })
  })

  createApp({
    name: 'TemplatesProductModal',
    components: {
      FButton,
      FModal,
    },
    data() {
      return {
        isStoresStockModalShow: window.location.href.includes('#inventory'),
        regions: regionKeys,
        indexSelectedRegion,
      }
    },
    computed: {
      storesToShow() {
        return storesGrouped[this.indexSelectedRegion]
      },
    },
    created() {
      const elementsTrigger = document.getElementsByClassName(
        'js-modal-product-stock-trigger'
      )
      if (elementsTrigger.length) {
        Array.from(elementsTrigger).forEach((element) => {
          element.addEventListener('click', () => {
            this.isStoresStockModalShow = true
          })
        })
      }
    },
  }).mount(element)
}
